module.exports = __webpack_public_path__ + "static/q1-ae86de0fc207db5e19886e004c250916.png";